/*  React  */
import React, { createContext, useContext, useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router';

export const TagEditorTableContext = createContext({});

export const TagEditorTableContextProvider = ({ children }) => {
    const { t } = useTranslation();

    const { clientId, partnerId } = useParams();
    const platformTenantId = clientId || partnerId;

    const [openAddTagModal, setOpenAddTagModal] = useState(false);
    const [editingTagId, setEditingTagId] = useState(null);

    const providerValues = useMemo(
        () => ({
            editingTagId,
            openAddTagModal,
            platformTenantId,
            setEditingTagId,
            setOpenAddTagModal,
            t
        }),
        [
            t,
            editingTagId,
            openAddTagModal,
            setEditingTagId,
            setOpenAddTagModal,
            platformTenantId
        ]
    );

    return (
        <TagEditorTableContext.Provider value={providerValues}>
            {children}
        </TagEditorTableContext.Provider>
    );
};

export const useTagEditorTableContext = () => {
    const context = useContext(TagEditorTableContext);

    if (context === undefined) {
        throw new Error(
            '`useTagEditorTableContext` must be used within `TagEditorTableContextProvider`'
        );
    }

    return context;
};
